import { deepOrange, green, lightBlue, red } from '@mui/material/colors';
import type { Components } from '@mui/material/styles';
import { type Theme } from '@mui/material/styles';

export const snackbarTheme: Pick<Components<Theme>, 'MuiSnackbarContent'> = {
  MuiSnackbarContent: {
    styleOverrides: {
      // fixing unaccessible colors for button with variant text
      action: ({ theme }) => ({
        '.MuiButton-textPrimary': {
          color: (theme.vars || theme).palette.arcticBlue.A100,
          ...theme.applyStyles('dark', {
            color: (theme.vars || theme).palette.arcticBlue[500],
          }),
        },
        '.MuiButton-textSecondary': {
          color: (theme.vars || theme).palette.arcticSunset[300],
          ...theme.applyStyles('dark', {
            color: deepOrange[900],
          }),
        },
        '.MuiButton-textError': {
          color: red[200],
          ...theme.applyStyles('dark', {
            color: red[700],
          }),
        },
        '.MuiButton-textWarning': {
          color: deepOrange[300],
          ...theme.applyStyles('dark', {
            color: deepOrange[900],
          }),
        },
        '.MuiButton-textInfo': {
          color: (theme.vars || theme).palette.arcticBlue[300],
          ...theme.applyStyles('dark', {
            color: lightBlue[800],
          }),
        },
        '.MuiButton-textSuccess': {
          color: green[300],
          ...theme.applyStyles('dark', {
            color: green[800],
          }),
        },
      }),
    },
  },
};
